import { Stack } from "@mui/material";
import { Switch } from "features/shared/components/Switch";
import { useTranslation } from "react-i18next";

import type { CrremSettings, EnergyAnalysisSettingsChange } from "../model/types";

type CorrectionKey = "climateCorrectionEnabled" | "coverageCorrectionEnabled" | "vacancyCorrectionEnabled";

const CORRECTIONS: { key: CorrectionKey; labelKey: "climate" | "coverage" | "vacancy" }[] = [
  { key: "climateCorrectionEnabled", labelKey: "climate" },
  { key: "vacancyCorrectionEnabled", labelKey: "vacancy" },
  { key: "coverageCorrectionEnabled", labelKey: "coverage" },
];

type EnergyAnalysisCorrectionSwitchesProps = {
  disabled?: boolean;
  onChange: EnergyAnalysisSettingsChange;
  settings: CrremSettings;
};

export const EnergyAnalysisCorrectionSwitches = ({
  disabled,
  onChange,
  settings,
}: EnergyAnalysisCorrectionSwitchesProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="items-center gap-4">
      {CORRECTIONS.map((correction) => (
        <Switch
          checked={settings[correction.key]}
          disabled={disabled}
          key={correction.key}
          className="!mr-0 gap-1"
          label={t(`BuildingProfile.energyAnalysis.settings.${correction.labelKey}`)}
          onChange={(checked) => onChange(correction.key, checked)}
          size="small"
        />
      ))}
    </Stack>
  );
};
